import {Badge} from '@/components/ui/badge';

type EvacuationCountBadgeProps = {
  confirmedCount: number;
  totalCount: number;
};

const EvacuationCountBadge = ({
  confirmedCount,
  totalCount,
}: EvacuationCountBadgeProps) => (
  <Badge
    variant="outlined"
    color={
      totalCount > 0 && confirmedCount === totalCount ? 'success' : 'neutral'
    }
  >
    {confirmedCount} / {totalCount}
  </Badge>
);

export default EvacuationCountBadge;
